import { render, staticRenderFns } from "./Uploader.vue?vue&type=template&id=41501bd3"
import script from "./Uploader.vue?vue&type=script&lang=js"
export * from "./Uploader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@2.0.1_webpack@4.47.0__css-loader@1.0.1_webpack@4.47.0___a965578a4a18db21b1dac13b221d5bdb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports